import { Component, OnInit, signal } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Asset } from '@app/models/asset/asset';
import { AssetSearchCommand } from '@app/models/asset/assetSearchCommand';
import { AssetProxyService } from '@app/proxies/asset/asset.proxy.service';

@Component({
  selector: 'app-finishing-dashboard',
  templateUrl: './finishing-dashboard.component.html',
  styleUrl: './finishing-dashboard.component.scss',
})
export class FinishingDashboardComponent implements OnInit {
  allAssets = signal<Asset[]>([]);
  filteredAssets = signal<Asset[]>([]);
  isloading = 0;

  constructor(private readonly assetProxyService: AssetProxyService) {}

  ngOnInit(): void {
    this.getAssetAvailableMachines();
  }

  private getAssetAvailableMachines() {
    const command: AssetSearchCommand = {
      assetCategoryReference: '67fdbaa6f37a22aafe95f6e0',
    };

    this.isloading++;
    this.assetProxyService.filterAssets(command).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          const assetsAvailable = response.data.sort((a, b) => this.sortByFirstProcess(a, b));

          this.allAssets.set(assetsAvailable);
          this.filteredAssets.set(assetsAvailable);
        }
        this.isloading--;
      },
      error: () => {
        this.isloading--;
        console.log('error');
      },
    });
  }

  filterMachineByTerm(event: AutoCompleteCompleteEvent) {
    const query = event.query.trim().toLowerCase();

    if (!query) {
      this.filteredAssets.set(this.allAssets());
      return;
    }

    const filtered = this.allAssets()
      .filter(
        (asset) => asset.assetId.toLowerCase().includes(query) || (asset.description && asset.description.toLowerCase().includes(query)),
      )
      .sort((a, b) => this.sortByFirstProcess(a, b));
    this.filteredAssets.set(filtered);
  }

  onClearSearch() {
    this.filteredAssets.set(this.allAssets());
  }

  private sortByFirstProcess(a: Asset, b: Asset): number {
    const getFirstProcessOrder = (asset: Asset): number => {
      const processId = asset.scanningStationDetails?.processNames?.[0]?.processId;
      if (!processId) return Infinity;
      const parsed = Number(processId);
      return isNaN(parsed) ? Infinity : parsed;
    };
    const processDiff = getFirstProcessOrder(a) - getFirstProcessOrder(b);
    if (processDiff !== 0) return processDiff;
    return a.assetId.localeCompare(b.assetId);
  }
}
